'use client'

import { useSyncExternalStore } from 'react'
import { useTheme } from 'next-themes'
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

const THEMES = [
  { value: 'system', icon: MonitorIcon, label: 'System' },
  { value: 'light', icon: SunIcon, label: 'Light' },
  { value: 'dark', icon: MoonIcon, label: 'Dark' },
] as const

const noopSubscribe = (): (() => void) => () => {}

export function ThemeSwitcher({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme()
  const mounted = useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false
  )

  if (!mounted) {
    return (
      <div className={cn('flex h-8 items-center gap-0.5 rounded-lg bg-muted p-0.5', className)} />
    )
  }

  return (
    <div className={cn('flex h-8 items-center gap-0.5 rounded-lg bg-muted p-0.5', className)}>
      {THEMES.map(({ value, icon: Icon, label }) => (
        <Button
          key={value}
          variant="ghost"
          size="icon-xs"
          className={cn(
            'size-7 rounded-md transition-colors duration-200',
            theme === value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
          onClick={() => setTheme(value)}
          aria-label={label}
        >
          <Icon className="size-3.5" />
        </Button>
      ))}
    </div>
  )
}
